import React from 'react'
import { FormattedMessage } from 'react-intl'
import { toastr } from 'react-redux-toastr'
import _ from 'lodash'
import log from 'loglevel'

import Body from './components/Body'

const resolveText = (value) => {
    if (_.isEmpty(value)) return null

    let textSettings = { id: null, values: {}, text: null }

    if (_.isPlainObject(value)) {
        textSettings = {
            ...textSettings,
            ...value,
        }
    } else {
        textSettings.id = value
    }

    if (textSettings.id) {
        return (
            <FormattedMessage
                id={textSettings.id}
                values={{ b: (chunks) => <b>{chunks}</b>, br: <br />, ...(textSettings?.values ?? {}) }}
            />
        )
    }

    return textSettings.text
}

const toast = (type = 'info', text = null, title = null, option = {}) => {
    const textComponent = resolveText(text)
    const titleComponent = resolveText(title)

    if (!toastr[type]) {
        log.error(`Wrong type of toastr message: ${type}`)
        return
    }

    toastr[type]('', {
        showCloseButton: false,
        component: <Body title={titleComponent} text={textComponent} />,
        ...option,
    })
}

export const success = (textId = null, titleId = null, option = {}) => {
    toast('success', textId, titleId, option)
}

export const info = (textId = null, titleId = null, option = {}) => {
    toast('info', textId, titleId, option)
}

export const warning = (textId = null, titleId = null, option = {}) => {
    toast('warning', textId, titleId, option)
}

export const error = (textId = null, titleId = null, option = {}) => {
    toast('error', textId, titleId, option)
}

export default toast
